/**
 * Glossary and writing guide for the VONK platform (U-160).
 *
 * Words
 * - startup: the company. deal: its route through the phases. dossier: the page of
 *   one startup.
 * - "Dealbord" is the board of active deals (not "Deal-overview"; that word stays a
 *   search term in the command palette). "Mijn taken" is the one task page.
 *   "Founderportaal" is the portal founders log in to. "Eigenaar" is the VONK
 *   person responsible for a deal. "gesprek" is the Kennismaking conversation.
 * - Write "pre-invest" and "post-invest" in lower case inside a sentence; the
 *   module names in the switcher are "Pre-invest", "Post-invest" and "Relaties".
 * - Write "dagen" in full, never "d".
 *
 * Style
 * - Buttons: infinitive plus object ("Taak toevoegen", "Deal afwijzen").
 * - Toasts: a short sentence that ends with a full stop.
 * - Use the single character '…' for an ellipsis, never three dots.
 */

export const NAV_LABELS = {
  board: 'Dealbord',
  myTasks: 'Mijn taken',
  founderPortal: 'Founderportaal',
  security: 'Beveiliging (2FA)',
  signOut: 'Uitloggen',
  home: 'Naar startpagina',
} as const

export const PORTAL_LABEL = 'Founderportaal'

/** Where founders log in; tasks managed there link to it. */
export const PORTAL_URL = 'https://portal.vonk.ventures'

export const MODULE_LABELS = {
  preinvest: 'Pre-invest',
  postinvest: 'Post-invest',
  relaties: 'Relaties',
} as const

export const TERMS = {
  startup: 'het bedrijf',
  deal: 'het traject van een startup door de fasen',
  dossier: 'de pagina van één startup',
  board: 'Dealbord',
  owner: 'Eigenaar',
  conversation: 'gesprek',
} as const
